module.exports = __webpack_public_path__ + "static/media/04_game_play_balloon.4bbd94cb.jpg";